import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";

const TableRow = React.memo((props) => {
  const { rowIndex, headers, onToggleModerator, onActivateNewCommunityRequest, onRemoveNewCommunityRequest } = props;
  const [row, setRow] = useState(props.row);
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE;

  const onToggleSwitch = (event, communityRow) => {
    const isChecked = event.target.checked;
    const updatedRow = { ...row, isPMStatus: isChecked };
    setRow(updatedRow);
    onToggleModerator(isChecked, communityRow);
  };

  return (
    <tr key={rowIndex}>
      {Object.entries(headers).map(([label, key], colIndex) => {
        if (label === "Image") {
          return (
            <td key={colIndex}>
              <img
                src={`${imageServerURL}${row.uimage}`}
                alt="User"
                width={50}
                height={50}
                style={{ borderRadius: "4px", objectFit: "cover" }}
              />
            </td>
          );
        } else if (label === "Moderator") {
          return (
            <td key={colIndex}>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={!!row[key]}
                  onChange={(e) => onToggleSwitch(e, row)}
                />
                <span className="moderator_approve_switch_by_admin round"></span>
              </label>
            </td>
          );
        } else if (label === "Activation Request") {
          const activationRequest = row.emailcheck;
          const activationRequestColor = activationRequest === "YES" ? "green" : "red"
          return (
            <td key={colIndex}>
              <span style={{ color: activationRequestColor, fontWeight: "bold" }}>
                {activationRequest}
              </span>
            </td>
          );
        } else if (label === "Activate") {
          return (
            <td key={colIndex}>
              <button
                className="activate_button"
                onClick={() => onActivateNewCommunityRequest(row.tenantId)}
              >
                Activate
              </button>
            </td>
          );
        } else if (label === "Dismiss") {
          return (
            <td key={colIndex}>
              <button
                className="activate_button"
                onClick={() => onRemoveNewCommunityRequest(row[key])}
              >
                Dismiss
              </button>
            </td>
          );
        } else {
          return (
            // <td key={colIndex} title={row[key]}>
            //   {row[key] || "-"}
            // </td>
            //   <Tooltip title={row[key]}>
            //   <td key={colIndex}>{row[key] || "-"}</td>
            // </Tooltip>
            <Tooltip
              title={row[key]}
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "gray",
                    color: "white",
                    fontSize: 13,
                    padding: "6px 10px",
                    borderRadius: "4px",
                  },
                  arrow: {
                    sx: {
                      color: "gray", // arrow color matches background
                    },
                  },
                },
              }}
            >
              <td key={colIndex}>{row[key] || "-"}</td>
            </Tooltip>
          );
        }
      })}
    </tr>
  );
});

export default TableRow;
